var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsdetail"},[_c('div',{staticClass:"detailbody",domProps:{"innerHTML":_vm._s(_vm.detail.newsdetail)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }